var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-avatar',_vm._g(_vm._b({class:{ 'text-body-1': true, 'mx-1': true, toFront: hover },style:(_vm.outlined),attrs:{"color":_vm.avatarColor,"size":_vm.size},domProps:{"textContent":_vm._s(_vm.userInitials)}},'v-avatar',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }